// © Copyright 2026 Emman Consulting SAS
// ─── ALBUM DATA ──────────────────────────────────────────────────────

export const GROUPS = [
{id:"A",teams:["MEX","RSA","KOR","CZE"]},{id:"B",teams:["CAN","BIH","QAT","SUI"]},
{id:"C",teams:["BRA","MAR","HAI","SCO"]},{id:"D",teams:["USA","PAR","AUS","TUR"]},
{id:"E",teams:["GER","CUW","CIV","ECU"]},{id:"F",teams:["NED","JPN","SWE","TUN"]},
{id:"G",teams:["BEL","EGY","IRN","NZL"]},{id:"H",teams:["ESP","CPV","KSA","URU"]},
{id:"I",teams:["FRA","SEN","IRQ","NOR"]},{id:"J",teams:["ARG","ALG","AUT","JOR"]},
{id:"K",teams:["POR","COD","UZB","COL"]},{id:"L",teams:["ENG","CRO","GHA","PAN"]},
];

export const TEAMS = {
MEX:{n:"México",en:"Mexico",cc:"mx"},RSA:{n:"Sudáfrica",en:"South Africa",cc:"za"},KOR:{n:"Corea del Sur",en:"South Korea",cc:"kr"},CZE:{n:"República Checa",en:"Czech Republic",cc:"cz"},
CAN:{n:"Canadá",en:"Canada",cc:"ca"},SUI:{n:"Suiza",en:"Switzerland",cc:"ch"},QAT:{n:"Qatar",en:"Qatar",cc:"qa"},BIH:{n:"Bosnia",en:"Bosnia",cc:"ba"},
BRA:{n:"Brasil",en:"Brazil",cc:"br"},MAR:{n:"Marruecos",en:"Morocco",cc:"ma"},SCO:{n:"Escocia",en:"Scotland",cc:"gb-sct"},HAI:{n:"Haití",en:"Haiti",cc:"ht"},
USA:{n:"EE.UU.",en:"USA",cc:"us"},AUS:{n:"Australia",en:"Australia",cc:"au"},PAR:{n:"Paraguay",en:"Paraguay",cc:"py"},TUR:{n:"Turquía",en:"Turkey",cc:"tr"},
GER:{n:"Alemania",en:"Germany",cc:"de"},ECU:{n:"Ecuador",en:"Ecuador",cc:"ec"},CIV:{n:"Costa de Marfil",en:"Ivory Coast",cc:"ci"},CUW:{n:"Curazao",en:"Curaçao",cc:"cw"},
NED:{n:"Países Bajos",en:"Netherlands",cc:"nl"},JPN:{n:"Japón",en:"Japan",cc:"jp"},TUN:{n:"Túnez",en:"Tunisia",cc:"tn"},SWE:{n:"Suecia",en:"Sweden",cc:"se"},
BEL:{n:"Bélgica",en:"Belgium",cc:"be"},IRN:{n:"Irán",en:"Iran",cc:"ir"},EGY:{n:"Egipto",en:"Egypt",cc:"eg"},NZL:{n:"Nueva Zelanda",en:"New Zealand",cc:"nz"},
ESP:{n:"España",en:"Spain",cc:"es"},URU:{n:"Uruguay",en:"Uruguay",cc:"uy"},KSA:{n:"Arabia Saudita",en:"Saudi Arabia",cc:"sa"},CPV:{n:"Cabo Verde",en:"Cape Verde",cc:"cv"},
FRA:{n:"Francia",en:"France",cc:"fr"},SEN:{n:"Senegal",en:"Senegal",cc:"sn"},NOR:{n:"Noruega",en:"Norway",cc:"no"},IRQ:{n:"Irak",en:"Iraq",cc:"iq"},
ARG:{n:"Argentina",en:"Argentina",cc:"ar"},AUT:{n:"Austria",en:"Austria",cc:"at"},ALG:{n:"Algeria",en:"Algeria",cc:"dz"},JOR:{n:"Jordania",en:"Jordan",cc:"jo"},
POR:{n:"Portugal",en:"Portugal",cc:"pt"},COL:{n:"Colombia",en:"Colombia",cc:"co"},UZB:{n:"Uzbekistán",en:"Uzbekistan",cc:"uz"},COD:{n:"RD Congo",en:"DR Congo",cc:"cd"},
ENG:{n:"Inglaterra",en:"England",cc:"gb-eng"},CRO:{n:"Croacia",en:"Croatia",cc:"hr"},PAN:{n:"Panamá",en:"Panama",cc:"pa"},GHA:{n:"Ghana",en:"Ghana",cc:"gh"},
};

export const FLAG_EMOJIS = {
MEX: '🇲🇽', RSA: '🇿🇦', KOR: '🇰🇷', CZE: '🇨🇿',
CAN: '🇨🇦', BIH: '🇧🇦', QAT: '🇶🇦', SUI: '🇨🇭',
BRA: '🇧🇷', MAR: '🇲🇦', HAI: '🇭🇹', SCO: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
USA: '🇺🇸', AUS: '🇦🇺', PAR: '🇵🇾', TUR: '🇹🇷',
GER: '🇩🇪', ECU: '🇪🇨', CIV: '🇨🇮', CUW: '🇨🇼',
NED: '🇳🇱', JPN: '🇯🇵', TUN: '🇹🇳', SWE: '🇸🇪',
BEL: '🇧🇪', IRN: '🇮🇷', EGY: '🇪🇬', NZL: '🇳🇿',
ESP: '🇪🇸', URU: '🇺🇾', KSA: '🇸🇦', CPV: '🇨🇻',
FRA: '🇫🇷', SEN: '🇸🇳', NOR: '🇳🇴', IRQ: '🇮🇶',
ARG: '🇦🇷', AUT: '🇦🇹', ALG: '🇩🇿', JOR: '🇯🇴',
POR: '🇵🇹', COL: '🇨🇴', UZB: '🇺🇿', COD: '🇨🇩',
ENG: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', CRO: '🇭🇷', PAN: '🇵🇦', GHA: '🇬🇭',
PANINI: '🏆', FWC: '⭐', CC: '👑',
};

export const GROUP_THEMES = {
A:{gs:"#7F1D1D",gm:"#DC2626",ge:"#FCA5A5"},B:{gs:"#1E3A8A",gm:"#2563EB",ge:"#93C5FD"},
C:{gs:"#14532D",gm:"#16A34A",ge:"#86EFAC"},D:{gs:"#701A75",gm:"#A21CAF",ge:"#E879F9"},
E:{gs:"#78350F",gm:"#D97706",ge:"#FCD34D"},F:{gs:"#0C4A6E",gm:"#0284C7",ge:"#7DD3FC"},
G:{gs:"#3B0764",gm:"#7C3AED",ge:"#C4B5FD"},H:{gs:"#431407",gm:"#EA580C",ge:"#FED7AA"},
I:{gs:"#7F1D1D",gm:"#B91C1C",ge:"#FCA5A5"},J:{gs:"#064E3B",gm:"#059669",ge:"#6EE7B7"},
K:{gs:"#2E1065",gm:"#6D28D9",ge:"#C4B5FD"},L:{gs:"#831843",gm:"#BE185D",ge:"#F9A8D4"},
};

export const GC = ["#E8192C","#003DA5","#00A651","#C8006B","#F5B800","#00B5E2","#9333EA","#F97316","#0EA5E9","#059669","#6D28D9","#BE185D"];

export const CC_PLAYERS = [
{code:"CC ESP-YAM",label:"Lamine Yamal",country:"España",countryEn:"Spain",cc:"es"},
{code:"CC GER-KIM",label:"Joshua Kimmich",country:"Alemania",countryEn:"Germany",cc:"de"},
{code:"CC ENG-KAN",label:"Harry Kane",country:"Inglaterra",countryEn:"England",cc:"gb-eng"},
{code:"CC MEX-GIM",label:"Santiago Giménez",country:"México",countryEn:"Mexico",cc:"mx"},
{code:"CC CRO-GVA",label:"Joško Gvardiol",country:"Croacia",countryEn:"Croatia",cc:"hr"},
{code:"CC URU-VAL",label:"Federico Valverde",country:"Uruguay",countryEn:"Uruguay",cc:"uy"},
{code:"CC COL-LER",label:"Jefferson Lerma",country:"Colombia",countryEn:"Colombia",cc:"co"},
{code:"CC ECU-ENN",label:"Enner Valencia",country:"Ecuador",countryEn:"Ecuador",cc:"ec"},
{code:"CC BRA-MAG",label:"Gabriel Magalhães",country:"Brasil",countryEn:"Brazil",cc:"br"},
{code:"CC NED-VDK",label:"Virgil van Dijk",country:"Países Bajos",countryEn:"Netherlands",cc:"nl"},
{code:"CC CAN-DAV",label:"Alphonso Davies",country:"Canadá",countryEn:"Canada",cc:"ca"},
{code:"CC ARG-EMI",label:"Emiliano Martínez",country:"Argentina",countryEn:"Argentina",cc:"ar"},
{code:"CC MEX-RAU",label:"Raúl Jiménez",country:"México",countryEn:"Mexico",cc:"mx"},
{code:"CC ARG-MAR",label:"Lautaro Martínez",country:"Argentina",countryEn:"Argentina",cc:"ar"},
];

export const CC_TOTAL = CC_PLAYERS.length;
export const ALBUM_TOTAL = 1 + 19 + CC_TOTAL + 48 * 20; // panini + fwc + cc + groups

const PANINI_LABELS = ["Logo Panini"];
export const PANINI = PANINI_LABELS.map((label) => ({ code: "00", label }));

const FWC_LABELS = Array.from({length:19},(_,i)=>`FWC${(i+1<10?"0"+(i+1):""+(i+1))}`);
export const FWC = FWC_LABELS.map((label,i)=>({code:"FWC "+(i+1<10?"0"+(i+1):""+(i+1)),label}));

export const flagUrl = cc => cc ? "https://flagcdn.com/w40/"+cc.toLowerCase()+".png" : "";
export const flagUrlWebp = cc => cc ? "https://flagcdn.com/w40/"+cc.toLowerCase()+".webp" : "";
export const flagSrcSet = cc => {
  if (!cc) return "";
  const ccLower = cc.toLowerCase();
  return `https://flagcdn.com/w20/${ccLower}.png 20w, https://flagcdn.com/w40/${ccLower}.png 40w, https://flagcdn.com/w80/${ccLower}.png 80w`;
};

export const sk = (tc, i) => tc + " " + (i < 10 ? "0" + i : "" + i);

export const buildEmpty = () => {
  const c = {};
  PANINI.forEach(s => { c[s.code] = { owned: false, quantity: 0 }; });
  FWC.forEach(s => { c[s.code] = { owned: false, quantity: 0 }; });
  CC_PLAYERS.forEach(s => { c[s.code] = { owned: false, quantity: 0 }; });
  GROUPS.forEach(g => g.teams.forEach(tc => {
    for (let i = 1; i <= 20; i++) c[sk(tc, i)] = { owned: false, quantity: 0 };
  }));
  return c;
};
